import { Component, OnInit } from '@angular/core';
import { environment } from '@environments/environment';
import { AccountService } from './services/account-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'vennhealth';
  isAuthenticated = false;
  constructor(private accountService: AccountService) { }

  ngOnInit(): void {
    if (this.accountService.accountValue) {
      this.isAuthenticated = true;
    } else {
      this.isAuthenticated = false;
      window.location.href = environment.tessellonPortalLoginUrl;
    }
  }
}
